import athenaConfig from '../../config';
import ActivateTotpCutomizer from './activate-totp';
import BarcodeTotpCustomizer from './barcode-totp';
import EnrollManualTotpCustomizer from './enroll-manual-totp';
import EnrollTotpCustomizer from './enroll-totp';
import { CustomizeControllerArgs } from '../';
import BaseGroupCustomizer from '../base-group-customizer';
import { getSelectedProvider } from '../../utils/widget-facade';

const { classic } = athenaConfig;

export default class AuthenticatorAppEnrollClassic extends BaseGroupCustomizer {
  getGroupedCustomizers(args: CustomizeControllerArgs) {
    return [
      new EnrollTotpCustomizer(args),
      new BarcodeTotpCustomizer(args),
      new EnrollManualTotpCustomizer(args),
      new ActivateTotpCutomizer(args),
    ];
  }

  async shouldGroupCustomize() {
    return classic && getSelectedProvider() === 'GOOGLE';
  }
}
